// Renders a cycle MediaAsset (action/chronicle illustration) in gn styling.
// The image is not a plain URL — it is fetched as a Blob via api.cycleImageContent
// and shown through an object URL (same mechanism as the legacy CycleImage).

import { useEffect, useState } from "react";
import { api, type MediaAsset } from "../api";

export function GnCycleImage({ campaignId, asset }: { campaignId: string; asset: MediaAsset }) {
  const [src, setSrc] = useState<string | null>(null);

  useEffect(() => {
    if (asset.status !== "READY") {
      setSrc(null);
      return;
    }
    let cancelled = false;
    let url: string | null = null;
    void api
      .cycleImageContent(campaignId, asset.id)
      .then((blob) => {
        if (!cancelled) {
          url = URL.createObjectURL(blob);
          setSrc(url);
        }
      })
      .catch(() => undefined);
    return () => {
      cancelled = true;
      if (url) URL.revokeObjectURL(url);
    };
  }, [campaignId, asset.id, asset.status]);

  if (asset.status === "FAILED") return null;
  if (asset.status !== "READY" || !src) {
    return <div className="gn-img-pending">Иллюстрация создаётся…</div>;
  }
  return <img className="gn-img" src={src} alt="" />;
}
